/* eslint-disable react/no-unused-prop-types */
import { FC, ReactNode } from "react";

export interface TabProps {
  /**
   * A unique identifier for the tab.
   * This is used to identify which tab is active.
   */
  eventKey: string;
  /**
   * The title of the tab, displayed in the tab.
   */
  title: string;
  /**
   * Indicates if the tab is currently active.
   */
  isActive?: boolean;
  /**
   * The content of the tab, displayed when the tab is active.
   */
  children?: ReactNode;
  /**
   * TODO: Add icon support
   */
  // icon?: ReactNode;
}

const Tab: FC<TabProps> = function ({ children }) {
  return <>{children}</>;
};

Tab.defaultProps = {
  isActive: false,
  children: null,
};

export default Tab;
